<ng-container *ngIf="{ productionVersionState: productionVersionState$ | async, sharedDataState: sharedDataState$ | async } as states">
    <div class="production-version-container mat-elevation-z8">
        <div class="table-header" [formGroup]="filterFormGroup">

            <mat-form-field subscriptSizing="dynamic">
                <input formControlName="textFilter" matInput placeholder="Filter">
                <button mat-icon-button matSuffix aria-label="clear" *ngIf="filterFormGroup.controls.textFilter.value" (click)="clearTextFilter()">
                    <mat-icon>close</mat-icon>
                </button>
            </mat-form-field>
            <section formGroupName="typeFilters" [formGroup]="filterFormGroup.controls.typeFilters">
                <mat-checkbox formControlName="endProductsOnly">{{ "app.page.production-version.endproducts-only.label" | translate }}</mat-checkbox>
                <mat-checkbox formControlName="semiProductsOnly">{{ "app.page.production-version.semiproducts-only.label" | translate }}</mat-checkbox>
            </section>
        </div>
        <mat-progress-bar color="accent" [style.visibility]="(states.productionVersionState.isLoading || states.sharedDataState.isLoading)
        ? 'visible' : 'hidden'" mode="indeterminate"></mat-progress-bar>

        <div class="table-container">
            <table mat-table matSort [dataSource]="dataSource" matSortActive="costUnitId" matSortDirection="asc">


                <ng-container matColumnDef="articleNr">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ "app.model.production-version.articleNr.label" | translate }}</th>
                    <td mat-cell *matCellDef="let productionVersion">{{ (productionVersion | as : IProductionVersion).articleNr }}</td>
                </ng-container>

                <ng-container matColumnDef="costUnitId">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ "app.model.production-version.cost-unit.label" | translate }}</th>
                    <td mat-cell *matCellDef="let productionVersion">
                        <ng-container *ngIf="states.sharedDataState.isLoading; else showCostUnitName">
                            <mat-progress-bar color="accent" mode="indeterminate"></mat-progress-bar>
                        </ng-container>

                        <ng-template #showCostUnitName>
                            <ng-container *ngIf="states.sharedDataState.costUnitLookup[productionVersion.costUnitId]; else missingCostUnit">
                                {{states.sharedDataState.costUnitLookup[productionVersion.costUnitId].name}}
                            </ng-container>

                            <ng-template #missingCostUnit>-</ng-template>

                        </ng-template>
                    </td>
                </ng-container>

                <ng-container matColumnDef="incomingRecipeNr">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header arrowPosition="before">{{ "app.model.production-version.incoming-recipe.label" | translate }}</th>
                    <td mat-cell *matCellDef="let productionVersion">{{ (productionVersion | as : IProductionVersion).incomingRecipeNr }}</td>
                </ng-container>

                <ng-container matColumnDef="outgoingRecipeNr">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header arrowPosition="before">{{ "app.model.production-version.outgoing-recipe.label" | translate }}</th>
                    <td mat-cell *matCellDef="let productionVersion">{{ (productionVersion | as : IProductionVersion).outgoingRecipeNr }}</td>
                </ng-container>

                <ng-container matColumnDef="version">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header arrowPosition="before">{{ "app.model.production-version.version.label" | translate }}</th>
                    <td mat-cell *matCellDef="let productionVersion">{{ (productionVersion | as : IProductionVersion).version }}</td>
                </ng-container>

                <ng-container matColumnDef="workingPlanNr">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header arrowPosition="before">{{ "app.model.production-version.workingPlanNr.label" | translate }}</th>
                    <td mat-cell *matCellDef="let productionVersion">{{ (productionVersion | as : IProductionVersion).workingPlanNr }}</td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="layout.columns; sticky: true"></tr>
                <tr mat-row class="row-hover clickable" *matRowDef="let row; columns: layout.columns;" (click)="openProductionVersion(row)"></tr>
            </table>
        </div>


    </div>
</ng-container>
